import Accounting from 'accounting-js';
import CurrencySymbolMap from 'currency-symbol-map';
import result from 'lodash.result';
import moment from 'moment';

const { formatNumber, formatMoney } = Accounting;

export default {
    methods: {
        // accepts only amount properties which have currency sibling
        formatMoneyCol(row, column) {
            const propPath = column.property.replace(/\.amount$/, '');
            const money = result(row, propPath);
            return money
                ? this.formatMoney(money.amount, money.currency)
                : '-'; // if no field found just show -
        },
        formatMoney(amount, currency, precision) {
            return formatMoney(Number(amount) || 0, {
                symbol: CurrencySymbolMap(currency || 'USD') || '$',
                format: '%s %v',
                precision: precision || 2,
            });
        },
        formatCurrency(amount, currency, precision) {
            return formatMoney(Number(amount) || 0, {
                symbol: currency || '',
                format: '%s %v',
                precision: precision || 2,
            });
        },
        formatRateCol(row, column) {
            return this.formatRate(result(row, column.property));
        },
        safeDivision(n, d) {
            return d ? n / d : null;
        },
        safeDivisionRate(n, d) {
            const d1 = this.safeDivision(n, d);
            return d1 ? d1 * 100 : null;
        },
        formatPureRate(value, precision = 2) {
            return `${ formatNumber((Number(value) || 0), { precision }) }%`;
        },
        formatRate(value, precision = 2) {
            return `${ formatNumber((Number(value) || 0) * 100, { precision }) }%`;
        },
        rateCol(row, column) {
            return this.formatPercentage(result(row, column.property));
        },
        formatPercentage(value, precision = 2) {
            return `${ formatNumber((Number(value) || 0), { precision }) }%`;
        },
        formatNumberCol(row, column) {
            const val = result(row, column.property);
            if (Number.isNaN(val)) {
                return '-';
            }
            return this.formatNumber(val);
        },
        formatNumber(value, precision = 2) {
            return formatNumber(Number(value) || 0, {
                precision,
                stripZeros: true,
            });
        },
        formatInteger(value) {
            return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-';
        },
        formatDecimal(row, column) {
            return row[column.property] ? row[column.property].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '-';
        },
        formatSpend(row, column, placeholder) {
            if (placeholder && !row[column.property]) {
                return placeholder;
            }
            return this.formatMoney(row[column.property], row['currency']);
        },
        formatDate(date) {
            return moment(date).format('YYYY/MM/DD');
        },
        formatCustomDate(date) {
            return moment(date).format('DD');
        },
        formatControlDateCol(row, column) {
            return `Ayın ${this.formatCustomDate(result(row, column.property))}. günü`;
        },
        formatDateTime(datetime) {
            return moment(datetime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
        },
        formatDateTimeCol(row, column) {
            return this.formatDateTime(result(row, column.property));
        },
        toTitleCaseCol(row, column) {
            return this.toTitleCase(result(row, column.property));
        },
        toTitleCase(str) {
            if (!str) {
                return str;
            }
            return str.replace(/[_\s]+/g, ' ')
                .split(' ')
                .map(s => s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase())
                .join(' ');
        },
        camelCaseToTitleCase(str) {
            if (!str) {
                return str;
            }
            return str
                .replace(/([A-Z]+)/g, ' $1')
                .replace(/([A-Z][a-z])/g, ' $1')
                .split(' ')
                .map(s => s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase())
                .join(' ');
        },
    },
};
